/* eslint-disable import/no-unresolved */
import _ from 'underscore';
import { useMemo, useRef } from 'react';
import { createUseStyles, useTheme } from 'react-jss';

import { ITheme, TGetStyles, PropsWithDefaultStyle } from './types';

const emptyTheme: ITheme = {};
const defaultProps = {};

const defaultGetStyles: TGetStyles = () => ({});

function useDeepMemo<T>(value: T): T {
  const ref = useRef<T | null>(null);
  if (!_.isEqual(value, ref.current)) {
    ref.current = value;
  }

  return ref.current as T;
}


export function useDefaultStyles<T = {}>(
  getStyles: TGetStyles = defaultGetStyles,
  props: PropsWithDefaultStyle<T> = defaultProps as PropsWithDefaultStyle<T>
) {
  const theme = useTheme<ITheme>();

  const useStyles = useMemo(
    () => {
      const { components = {}, core = {} } = theme || emptyTheme;
      return createUseStyles(getStyles(components, core));
    },
    [getStyles, theme]
  );

  const classes = useStyles(props);

  return useDeepMemo(classes);
}
